import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import CreateRCTIFilters from './CreateRCTIFilters';
import moment from 'moment';
import { getErrorMessage, mustBeArray, requestHasError } from '../../utils/lib';
import { BASE_URL, DEFAULT_DATE_FORMAT } from '../../constants';
import {loadClients} from '../../actions/clientActions';
import {clearRebatesRCTIInvoices, listRebatesRCTIInvoices, createRebatesRCTI, exportRebatesAsCsv} from '../../actions/rebatesRCTIActions';
import RebatesRCTIInvoiceList from './RebatesRCTIInvoiceList';
import { toastr } from 'react-redux-toastr';
import { push } from '../../utils/navigation';
import RebateRCTIErrorModal from './RebateRCTIErrorModal';
import _ from 'lodash';

const RebatesRCTICreate = props => {
    const {dispatch, clientList, invoiceList, listRebatesRCTIInvoices, 
            clearRebatesRCTIInvoices, createRebatesRCTI} = props;
    const [saveLoading, setSaveLoading] = useState(false);
    const [allSelected, setAllSelected] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [errors, setErrors]= useState(null);
    const [viewErrorModal, setViewErrorModal] = useState(false);
    const [filters, setFilters] = useState({ 
        dateFrom: moment().subtract(1,'months').startOf('month').format(DEFAULT_DATE_FORMAT),  
        dateTo: moment().subtract(1,'months').endOf('month').format(DEFAULT_DATE_FORMAT),
        clientId: []
    });
    const [rctiCreationDate, setRCTICreationDate] = useState(moment().format(DEFAULT_DATE_FORMAT));
    const [exporting, setExporting] = useState(false);

    // Keep track of errors after the save request
    useEffect(() => {
        if(errors){
            setViewErrorModal(true);
        }
    }, [errors]);

    // Close the error modal - reset errors
    const handleModalClose = () => {
        setViewErrorModal(false);
        setErrors(null);
    }

    const handleCsvExport = () => {
        setExporting(true);
        dispatch(exportRebatesAsCsv({...filters})).then(x => {
            setExporting(false);
        });
    }

    const handleFilterChange = ({value, field}) => {
        if(['dateFrom','dateTo'].includes(field)){
            value = value.format(DEFAULT_DATE_FORMAT);
        }
        if(field==="clientId"){
            let tempValue = value ? value.split(",") : [];
            if(tempValue.length > 1){
                value = tempValue[0] === "All" ? tempValue.filter(o => o !== "All") : 
                                tempValue[tempValue.length - 1] === "All" ? ["All"] : tempValue;
            }
            else{
                value = tempValue;
            }
        }
        let updatedFilters = {...filters, [field]: value};
        setFilters(updatedFilters);
    };

    useEffect(() => {
        dispatch(clearRebatesRCTIInvoices());
        fetchClients();
    }, []);

    const fetchClients = () => {
        dispatch(loadClients("",false, true, true));
    };
    const handleRCTICreationDateChange = value => {
        setRCTICreationDate(value.format(DEFAULT_DATE_FORMAT));
    };
    const handleCheckboxSelection = row => {
        let updatedSelectedRows = [];
        if(selectedRows.includes(row.locationID)){
            updatedSelectedRows = selectedRows.filter((a) => a !== row.locationID);
            setAllSelected(false);
        }
        else{
            updatedSelectedRows = [...selectedRows, row.locationID];
            if(updatedSelectedRows.length === invoiceList.length){
                setAllSelected(true);
            }
        }
        return setSelectedRows(updatedSelectedRows);
        
    };
    const handleAllSelected = () => {
        if(allSelected){
            setSelectedRows([]);
            setAllSelected(false);
        }
        else{
            let newSelectedRows = mustBeArray(invoiceList).reduce((a,b) => {
                return [...a,b.locationID];
            },[]);
            setSelectedRows(newSelectedRows);
            setAllSelected(true);
        }
    };

    const getClientIdsFromSelectedLocations = ({locations}) => {
        return mustBeArray(locations).reduce((a,b) => {
            return a.includes(b.clientID) || b.isRebateRecipient ? a : [...a,b.clientID];
        },[]);
    };

    const handleSave = () => {
        setSaveLoading(true);
        if(_.isEmpty(selectedRows)){
            setSaveLoading(false);
            return toastr.error("Saving Error: Client location is required.");
        }
        let selectedRebates = mustBeArray(invoiceList).filter(o => selectedRows.includes(o.locationID));

        // Separate the locations for which isRebateRecipient is set to true
        let locationWithRebatesRecipient =  mustBeArray(selectedRebates).filter(o => o.isRebateRecipient);
        // Find unique client ids for each selected locations
        const clientIDs = getClientIdsFromSelectedLocations({locations: selectedRebates});
        let payLoads = [];

        mustBeArray(locationWithRebatesRecipient).forEach(location => {
            let totalRebateAmountExcGst = Number(location.totalAmount || 0).toFixed(2);
            let gstAmount = Number(location.gst || 0).toFixed(2);
            let payLoad = {
                rctiDate: rctiCreationDate,
                clientID: location.clientID,
                exportStatusID: null,
                totalRebateAmount: (Number(totalRebateAmountExcGst) + Number(gstAmount)).toFixed(2),
                totalRebateAmountExcGst,
                gstAmount,
                rctiNumber: null,
                rebateRctiLines: [location],
                payToClient: false
            };
            payLoads = [...payLoads, payLoad];
        });
        clientIDs.forEach(client => {
            let rebateRctiLines = _.filter(selectedRebates, o => (o.clientID === client) && !o.isRebateRecipient);
            let totalRebateAmountExcGst = Number(rebateRctiLines.reduce((a,b) => {
                    return(a+b.totalAmount);
                },0)).toFixed(2);
            let gstAmount = Number(rebateRctiLines.reduce((a,b) => {
                    return(a+b.gst);
                },0)).toFixed(2);
            let totalRebateAmount = (Number(totalRebateAmountExcGst) + Number(gstAmount)).toFixed(2);
            let payLoad = {
                rctiDate: rctiCreationDate,
                clientID: client,
                exportStatusID: null,
                totalRebateAmount,
                totalRebateAmountExcGst,
                gstAmount,
                rctiNumber: null,
                rebateRctiLines,
                payToClient: true
            };
            payLoads = [...payLoads, payLoad];
        });
        dispatch(createRebatesRCTI({payLoad: payLoads})).then(x => {
            setSaveLoading(false);
            if(x.errors && (!_.isEmpty(mustBeArray(x.errors.invalidAbn)) || !_.isEmpty(mustBeArray(x.errors.invalidAccountName)) 
            || !_.isEmpty(mustBeArray(x.errors.invalidCompany)))){
                return setErrors(x.errors);
            }
            if(requestHasError({x})){
                return toastr.error(getErrorMessage({x}));
            }
            toastr.success("Rebates RCTI Created.");
            dispatch(push(`${BASE_URL}/rebatesRCTI`));
            
        });
    };

    const handleCancel = () => {
        dispatch(push(`${BASE_URL}/rebatesRCTI`));
    };

    const handleSearch = () => {
        setSelectedRows([]);
        fetchInvoices();
    };

    const handleReset = () => {
        setFilters({
            dateFrom: moment().subtract(1,'months').startOf('month').format(DEFAULT_DATE_FORMAT),  
            dateTo: moment().subtract(1,'months').endOf('month').format(DEFAULT_DATE_FORMAT), 
            clientId: ""});
        setSelectedRows([]);
        dispatch(clearRebatesRCTIInvoices());
    };

    const fetchInvoices = () => {
        dispatch(listRebatesRCTIInvoices({ ...filters }));
    };
    return(
        <React.Fragment>
            <div className={"row"}>
                <div className={"col-12"} style={{marginBottom: "24px"}}>
                    <h4>Create Rebates RCTI</h4>
                </div>
            </div>
            <CreateRCTIFilters
                filters={filters} 
                handleFilterChange={handleFilterChange}
                rctiCreationDate={rctiCreationDate} 
                handleRCTICreationDateChange={handleRCTICreationDateChange}
                clientList={[{id: "All", companyName: "All"},...clientList]}
                handleSearch = {handleSearch}
                handleReset = {handleReset}
                handleCsvExport={handleCsvExport}
                exporting={exporting}
            />
            <div className="clearfix"/>
            <RebatesRCTIInvoiceList 
                handleCheckboxSelection={handleCheckboxSelection}
                handleAllSelected={handleAllSelected}
                allSelected={allSelected}
                selectedRows={selectedRows}
                data={invoiceList}
                showGstAndSubTotal={true}
            />
            <div className="mt-2 mb-2">
                <button className={`btn btn-primary ${saveLoading ? "no-pointer-events" : ""}`} onClick={handleSave}>
                    <i className="fa fa-floppy-o" aria-hidden="true"></i> &nbsp;{saveLoading ? "Saving RCTI" : "Save RCTI"}
                </button>
                <button className="btn btn-default ml-1" onClick={handleCancel}>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i> &nbsp;Cancel
                </button>
                <div className="clearfix"/>
            </div>
            {/* Modal to display errors */}
            <RebateRCTIErrorModal 
                visible={viewErrorModal}
                errors={errors}
                handleModalClose={handleModalClose}
            />
            
        </React.Fragment>
    );
};

function mapStateToProps(state){
  
    return {
      invoiceList: state.rebatesRCTI && state.rebatesRCTI.invoices && state.rebatesRCTI.invoices.items,
      clientList: state.clients && state.clients.items, 
      gst: Number(state.apiConfig && state.apiConfig.gst)
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      loadClients,
      listRebatesRCTIInvoices,
      clearRebatesRCTIInvoices,
      createRebatesRCTI
    };
  }

export default connect(mapStateToProps, mapDispatchToProps) (RebatesRCTICreate);